import React, { useState, useEffect, useContext } from 'react';
import { Layout, Image, Space, Button, Input, Modal, Select, Form, message, Radio, Dropdown, Popover } from "antd";
import logo from '../../hire-logo-v2.svg';
import { Link } from "react-router-dom";
import { useAuth } from '../../services/AuthService';
import Cookies from 'js-cookie';
import moment from 'moment';
import constants from '../../constants/constants';
import { getBuyerNameById, getCurrencyName } from '../../globalFunctions/GlobalFunctions';
import WebLinks from '../../api/WebLinks';
import APIUtils from '../../api/APIUtils';
import {
  MenuOutlined,  UserOutlined,
  FileTextOutlined,
  LogoutOutlined, DownOutlined
} from "@ant-design/icons";
import { CommonContext, CurrencyContext } from '../../Context';
// import parserJobtrain from '../../assets/parserlinknames/cobrand-jobtrain.png';
import parserJobboardreach from '../../assets/parserlinknames/cobrand-jobboardreach.png';
import parserTribepad from '../../assets/parserlinknames/cobrand-tribepad.png';
import parserHarri from '../../assets/parserlinknames/cobrand-harri.png';
import parserPeoplebank from '../../assets/parserlinknames/cobrand-peoplebank.png';
import parserSona from '../../assets/parserlinknames/cobrand-sona.png';
import reportNameSchoolTalent from '../../assets/parserlinknames/schoolTalent.png';

const { Header } = Layout;
const { Option } = Select

const Headers = () => {
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [buttonSize, setButtonSize] = useState('small');
  const [formCreate] = Form.useForm();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [purchaseLoader, setPurchaseLoader] = useState(false);
  const isSelfService = sessionStorage.getItem('isSelfService');
  const options = Array.from({ length: 20 }, (_, i) => (i + 1) * 500);
  const optionsFree = Array.from({ length: 20 }, (_, i) => (i + 1) * 50);
  const currencyContext = useContext(CurrencyContext);
  const [isHIAdmin, setIsHIAdmin] = useState(false);
  const [paymentType, setPaymentType] = useState(null); // Default payment type
  const [accountPopoverOpen, setAccountPopoverOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const AllowCreditInvoicing = sessionStorage.getItem('allowCreditInvoicing');
  let saved = sessionStorage.getItem("common");
  const [isCreditInvoiceModalOpen, setIsCreditInvoiceModalOpen] = useState(false);
    const [creditInvoiceForm] = Form.useForm();
    const [countryList, setCountryList] = useState([]);
    const [countryLoader, setCountryLoader] = useState(false);
    const [hasSubmittedCreditInvoice, setHasSubmittedCreditInvoice] = useState(false);
    const [showCreditInvoiceSuccessMessage, setShowCreditInvoiceSuccessMessage] = useState(false);
    const [openTopupAfterCreditInvoiceClose, setOpenTopupAfterCreditInvoiceClose] = useState(false);
  //const AllowCreditInvoicing ="true"
  useEffect(() => {
    const updateSize = () => {
      setButtonSize(window.innerWidth < 768 ? 'small' : 'large');
    };

    updateSize(); // Initial check
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    const isAdmin = Cookies.get(constants.COOKIE_IS_ADMIN);
    setIsHIAdmin(isAdmin==="true"?"true":"false");
    fetchCountryList();
    //setIsHIAdmin("false")
  }, []);
  const { logoutAuth } = useAuth()

  const parserLogoSrc = (() => {
    const parser= sessionStorage.getItem('parserLink') || '';
    const key = parser.toString().toLowerCase();
    if (!key) return null;
    if (key.includes('schooltalent')) return reportNameSchoolTalent;
    if (key.includes('jobtrain')) return parserJobboardreach;
    if (key.includes('harri')) return parserHarri;
    if (key.includes('peoplebank')) return parserPeoplebank;
    if (key.includes('tribepad')) return parserTribepad;
    if (key.includes('sona')) return parserSona;
    return null;
  })();

  const handleCancel = () => {
    setPaymentType(null);
    formCreate.resetFields();
    setIsEditModalOpen(false);
  };

  const handleOpenTopupModal = () => {
    setShowCreditInvoiceSuccessMessage(false);
    setIsEditModalOpen(true);
  };

  const createCheckoutSession = async (amount, buyerOrdersId) => {
    let payload = {
      buyerId: buyerId,
      amount: amount,
      currency: getCurrencyName(currencyContext.currency),
      productName: "Credit Top Up",
      buyerOrdersId: buyerOrdersId
    }
    let method, url, body;
    method = "POST";
    url = WebLinks.CreateStripeSession;
    const response = await APIUtils.apiCall(method, url, JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      //window.open(`${response.resultObj.data}`,"_blank")
      setPurchaseLoader(false);
      // const popup = window.open('', '_blank');
      // popup.location.href = response.resultObj.data;
      window.location.href = response.resultObj.data;
      //message.success(response.resultObj.message);
    } else {
      setPurchaseLoader(false);
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

  //Function to save edited job
  const saveDetails = async (values) => {
    setPurchaseLoader(true);
    let payload = {
      buyerId: buyerId,
      contractAmount: values?.contractAmount,
      invoiceAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      purchaseOrderInfo: values?.orderInfo,
      billingDateStart: moment().format('YYYY-MM-DD'),
      billingDateEnd: moment().format('YYYY-MM-DD'),
      type: paymentType,
      confirmerName: values?.userName,
      freeCredits: paymentType === "free" ? true : false,
      doNotInvoice: paymentType === "free" ? true : false
    }
    let method, url, body;
    method = "POST";
    url = WebLinks.AddOrderContractAmountDetails;
    const response = await APIUtils.apiCall(method, url, JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      if (paymentType === "card" || (AllowCreditInvoicing === "false" && isHIAdmin === "false" && !hasSubmittedCreditInvoice)) {
        createCheckoutSession(values?.contractAmount, response.resultObj.buyerOrdersId);
        return;
      } else {
        setPurchaseLoader(false);
        commonContext.changeCommonValues({'boostCredits': response.resultObj?.boostCredits || 0});
        handleCancel();
        message.success(response.resultObj.message);
      }
    } else {
      setPurchaseLoader(false);
      handleCancel();
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };
  const mobileMenuItems = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: (
        <Link to="/settings" className="block w-full">
          Settings
        </Link>
      ),
    },
    {
      key: "logs",
      icon: <FileTextOutlined />,
      label: (
        <Link to="/activity-logs" className="block w-full">
          Logs
        </Link>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: () =>
        logoutAuth().then(() => {
          window.Intercom?.("shutdown");
          sessionStorage.clear();
          window.location.href = "/login";
        }),
    },
  ];
  const accountPopoverContent = (
    <div className="min-w-[200px]">
      {(sessionStorage.getItem('isSelfService') === "true" ||
        sessionStorage.getItem('isBoost') === "true") && (
          <div className="text-black text-xs font-semibold">
            Boost Credits: {commonContext.common.boostCredits}{' '}
            {getCurrencyName(currencyContext.currency)}
            <Button
              type="link"
              className="text-xs font-semibold !p-0 !pl-1"
              onClick={() => {
                setAccountPopoverOpen(false);
                handleOpenTopupModal();
              }}
            >
              Top up
            </Button>
          </div>
        )}
      <div className="mt-2 text-black text-xs font-semibold">
        {getBuyerNameById(
          saved ? JSON.parse(saved).buyerId :buyerId,
          sessionStorage.getItem("selectedbuyername")
        )}{' '}
        [{buyerId}]
      </div>
    </div>
  );
  const handleOpenCreditInvoiceModal = () => {
    setIsCreditInvoiceModalOpen(true);
  };

  const handleCloseCreditInvoiceModal = () => {
    creditInvoiceForm.resetFields();
    setIsCreditInvoiceModalOpen(false);
  };

  const handleSaveCreditInvoice = async (values) => {
    const payload = {
      buyerId: buyerId,
      companyLegalName: values?.companyLegalName,
      companyCity: values?.companyCity||"",
      companyAddress: values?.companyAddress||"",
      companyState: values?.companyState||"",
      companyZip: values?.companyZip||"",
      companyCountry: values?.companyCountry,
      invoiceEmail: values?.invoiceEmail,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
    };
    const response = await APIUtils.apiCall('POST', WebLinks.PostCreditInvoice, JSON.stringify(payload));
      if (!response.isCatch && response.resultObj && response.resultObj.statusCode === "2000") {
        message.success(response?.resultObj?.message );
        if (isSelfService === "true") {
          setHasSubmittedCreditInvoice(true);
          setPaymentType("invoice");
          formCreate.setFieldsValue({ type: "invoice" });
          setOpenTopupAfterCreditInvoiceClose(true);
        }
        handleCloseCreditInvoiceModal();
      } else {
        message.error(response?.resultObj?.message || constants.FAILED_SAVE);
      }
  };
    //Country list
  const fetchCountryList = async () => {
      setCountryLoader(true)
      const response = await APIUtils.apiCall("GET", WebLinks.GetCountryList);
      if (!response.isCatch) {
        setCountryList(response.resultObj.data)
      } else {
        message.error(response.resultObj.message);
      }
      setCountryLoader(false);
  }
  return (
    <Header className='flex justify-between items-center bg-transparent container mx-auto 2xl:max-w-full 2xl:px-4 mt-3 px-3 lg:px-0 h-min' id='top'>
      <div className="flex items-center gap-1 logo ml-8 lg:ml-0">
        <Image src={logo} preview={false} />
        {parserLogoSrc && (
          <>
            <span className="border-l-2 border-gray-300 mx-4 h-10 xl:h-[70px] 2xl:h-[90px] shrink-0" />
            <img src={parserLogoSrc} alt="partner" className="h-5 sm:h-6 md:h-8 lg:h-10 xl:h-[45px] 2xl:h-[84px] w-auto object-contain" />
          </>
        )}
      </div>
      <Space className='gap-2 md:gap-6'>
        <div className="hidden xl:flex bg-white rounded-full h-10 px-5 gap-5 place-items-center text-base">
          <span className="text-xs lg:text-sm whitespace-nowrap">
            {(sessionStorage.getItem('isSelfService') === "true" ||
              sessionStorage.getItem('isBoost') === "true") && (
                <span className="font-semibold">
                  Boost Credits: {commonContext.common.boostCredits}{" "}
                  {getCurrencyName(currencyContext.currency)}
                  <Button
                    type="link"
                    className="font-semibold pl-0"
                    onClick={() => {
                      setAccountPopoverOpen(false);
                      handleOpenTopupModal();
                    }}
                  >
                    Top up
                  </Button>
                </span>
              )}
            {getBuyerNameById(
              saved ? JSON.parse(saved).buyerId :buyerId,
              sessionStorage.getItem("selectedbuyername")
            )}{" "}
            [{buyerId}]
          </span>

          <Link to="/settings" className="font-bold">
            Settings
          </Link>

          <Link to="/activity-logs" className="font-bold">
            Logs
          </Link>
        </div>

        <Button
          type="primary"
          shape="round"
          size={buttonSize}
          className="hidden xl:inline-flex !text-sm"
          onClick={() =>
            logoutAuth().then(() => {
              window.Intercom?.("shutdown");
              sessionStorage.clear();
              window.location.href = "/login";
            })
          }
        >
          Logout
        </Button>

        {/* Mobile */}
        <div className="xl:hidden flex items-center gap-2">
            <Popover
              content={accountPopoverContent}
              trigger="click"
              placement="bottom"
              open={accountPopoverOpen}
              onOpenChange={setAccountPopoverOpen}
            >
              <Button
                shape="round"
                size="small"
                className="!h-7 !px-3 !bg-white"
              >
              <div className="whitespace-nowrap text-xs font-semibold flex items-center gap-2">
                {(sessionStorage.getItem('isSelfService') === "true" ||
                  sessionStorage.getItem('isBoost') === "true") ? (
                  <>
                    Credits:{" "}{commonContext.common.boostCredits}{" "}
                    {getCurrencyName(currencyContext.currency)}
                  </>
                ) : (
                  <span className="text-[12px]">
                    [{buyerId}]
                  </span>
                )}
                <DownOutlined style={{ fontSize: 9 }} className={`transition-transform duration-200 ${accountPopoverOpen ? "rotate-180" : "rotate-0"}`}/>
                </div>
              </Button>
            </Popover>
          <Dropdown
            arrow
            trigger={["click"]}
            placement="bottomRight"
            open={menuOpen}
            onOpenChange={setMenuOpen}
            overlayClassName="mobile-menu"
            menu={{ items: mobileMenuItems }}
          >
            <Button
              shape="circle"
              type="primary"
              className="!flex !items-center !gap-1 !w-9 !h-9"
            >
              <MenuOutlined style={{ fontSize: 16 }} />
            </Button>
          </Dropdown>
        </div>
      </Space>
      <Modal
        title={constants.BuyBoostCredits}
        open={isEditModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        //okText={<span className="capitalize">Save</span>}
        // onOk={() => form.submit()}
        style={{ top: 20 }}
        width={800}
        footer={paymentType !== null || AllowCreditInvoicing === "false" ?
          [
            <Button key="cancel" onClick={() => handleCancel()}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" loading={purchaseLoader} onClick={() => formCreate.submit()}>
              PURCHASE
            </Button>,
          ] : []
        }
      >
        <Form form={formCreate} name="form_in_modal" layout="vertical" onFinish={saveDetails}>
          <div >
            {showCreditInvoiceSuccessMessage && (
              <p className="mb-4 font-semibold">
                Thanks for providing your invoicing details. Please purchase some Top Up Credits
              </p>
            )}
            {AllowCreditInvoicing === "true" ? <>
              <Form.Item
                label="Select Payment Type"
                name="type"
              >
                <Radio.Group onChange={(e) => { setPaymentType(e.target.value); }}>
                  <Radio value="card">Card Payment</Radio>
                  <Radio value="invoice">Invoice</Radio>
                  {Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
                    <Radio value="free">Free Credits</Radio>
                  ) : null}
                </Radio.Group>
              </Form.Item>
            </> :
              Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ?
                <Form.Item
                  label="Select Payment Type"
                  name="type"
                >
                  <Radio.Group onChange={(e) => { setPaymentType(e.target.value); }}>
                    <Radio value="card">Card Payment</Radio>
                    <Radio value="free">Free Credits</Radio>
                  </Radio.Group>
                </Form.Item>
                :AllowCreditInvoicing==="false" && hasSubmittedCreditInvoice?
                  <Form.Item
                    label="Select Payment Type"
                    name="type"
                  >
                    <Radio.Group onChange={(e) => { setPaymentType(e.target.value); }}>
                      <Radio value="card">Card Payment</Radio>
                      <Radio value="invoice">Invoice</Radio>
                      {Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true ? (
                        <Radio value="free">Free Credits</Radio>
                      ) : null}
                    </Radio.Group>
                  </Form.Item>
                :AllowCreditInvoicing==="false"?
                  <Space>
                    <Form.Item
                      label="Select Payment Type"
                      name="typer"
                    >
                      <Radio.Group name='radio' defaultValue="card">
                          <Radio value="card">Card Payment</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item><Button className='mt-7' type="link" onClick={handleOpenCreditInvoiceModal}>Apply for Credit Invoicing</Button></Form.Item>
                    </Space>:
                null}
            {paymentType !== null || AllowCreditInvoicing === "false" ?
              <>
                <Form.Item
                  name="contractAmount"
                  label={`Credit Amount ${getCurrencyName(currencyContext.currency)}`}
                  rules={[
                    {
                      required: true,
                      message: "Required field",
                    },
                  ]}
                >
                  {/* <InputNumber min={0} className='w-full' placeholder="Amount"/> */}
                  {paymentType === "free" ?
                    <Select placeholder="Choose amount">
                      {optionsFree.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select> :
                    <Select placeholder="Choose amount">
                      {options.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>}
                </Form.Item>
                {paymentType !== "card" ?
                  <>
                    {isHIAdmin === "false" && AllowCreditInvoicing === "false" && !hasSubmittedCreditInvoice ? null :
                      <>
                        {paymentType === "invoice" ?
                          <>
                            <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
                            >
                              <Input placeholder='Order Info.' />
                            </Form.Item>
                            <Form.Item name="userName" label="Please enter your name to confirm"
                            >
                              <Input placeholder='Name' />
                            </Form.Item></>
                          :
                          <Form.Item name="orderInfo" label="Purchase Order Info. (optional)"
                          >
                            <Input placeholder='Order Info.' />
                          </Form.Item>
                        }
                      </>
                    }
                  </> : null}
              </> : null}
          </div>
        </Form>
      </Modal>
      <Modal
        title="Credit Invoicing Request"
        open={isCreditInvoiceModalOpen}
        afterOpenChange={(open) => {
          if (!open && openTopupAfterCreditInvoiceClose) {
            setShowCreditInvoiceSuccessMessage(true);
            setIsEditModalOpen(true);
            setOpenTopupAfterCreditInvoiceClose(false);
          }
        }}
        onCancel={handleCloseCreditInvoiceModal}
        zIndex={3000}
        footer={[
          <Button key="cancel" onClick={handleCloseCreditInvoiceModal}>Cancel</Button>,
          <Button key="submit" type="primary" onClick={() => creditInvoiceForm.submit()}>Save</Button>,
        ]}
        width={700}
      >
        <div className="mb-3">
          <p className="font-semibold mb-2">Please provide your invoicing details to be approved for credit invoicing:</p>
          <p className="text-xs text-gray-500 italic">*All invoices must be settled within the 30 day term or invoicing may be removed.</p>
        </div>
        <Form form={creditInvoiceForm} layout="vertical" onFinish={handleSaveCreditInvoice}>
          <Form.Item
            name="companyLegalName"
            label="Company Legal Name"
            rules={[{ required: true, message: 'Required field' }]}
          >
            <Input />
          </Form.Item>
          <div className="mb-3">
            <div className="mb-2 text-[14px] font-normal text-black-700">Company Details</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item
                name="companyAddress"
                label="Company Address"
                rules={[{ required: true, message: 'Required field' }]}
              >
                <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 6 }} />
              </Form.Item>
            {getCurrencyName(currencyContext.currency)==="GBP"?
              <Form.Item
                name="companyCity"
                label="Company City"
                rules={[{ required: true, message: 'Required field' }]}
              >
                <Input />
              </Form.Item>:null}
              {getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?null:
              <Form.Item
                name="companyState"
                label="Company State"
                rules={[{ required: true, message: 'Required field' }]}
              >
                <Input />
              </Form.Item>}
              <Form.Item
                name="companyZip"
                label={getCurrencyName(currencyContext.currency)==="GBP"||getCurrencyName(currencyContext.currency)==="EUR"?"Company Postcode":"Company Zip"}
                rules={[{ required: true, message: 'Required field' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="companyCountry"
                label="Company Country"
                rules={[{ required: true, message: 'Required field' }]}
              >
              <Select 
                    //onChange={(e)=>onCountryslect(e)} 
                allowClear 
                showSearch
                loading={countryLoader} 
                placeholder={<span className='text-sm normal-case'>Select Country</span>}  
                className="w-60"
                filterOption={(input, option) =>
                    (option?.props?.children ?? '').toLowerCase().includes(input.toLowerCase())
                }
                >
                <Option key="showall" value="showall">Show All</Option>
                <Option key="global" value="global">Global</Option>
                {countryList.map((item) => (
                <Option key={item.countryCode} value={item.countryCode}>{item.country}</Option>
                ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          <Form.Item
            name="invoiceEmail"
            label="Invoice Email"
            rules={[
              { required: true, message: 'Required field' },
              { type: 'email', message: 'Please enter a valid email address' },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Header>
  );
};
export default Headers;
